<template>
  <span :class="`bg-seats-${status}`" class="w-3 h-3 inline-flex rounded-full"></span>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SeatBulb',
  props: {
    status: { type: String, required: false, default: null },
  },
})
</script>
